export default{
    config:{
        // "fileUrl" :"http://localhost:24737/filedownload/",
        // "fileUrl":"http://121.41.11.131:8088/filedownload/",
        "fileUrl":"https://api.reaca.net/filedownload/", //用于导出
    },
    install:function(Vue){
        Object.defineProperty(Vue.prototype, '$config', { value: this.config });
    }
}